import React from "react";
import { Link } from "react-router-dom";
import logoDark from "assets/full_logo_horizontal_dark.png";
import logo from "assets/full_logo_horizontal_light.png";
import social_FB from "assets/social_fb.png";
import social_Insta from "assets/social_Insta.png";
import social_LI from "assets/social_LI.png";
import social_Twitter from "assets/social_twitter.png";
import { Footer, Navbar, useTheme } from "flowbite-react";

type SocialLinksType = {
	image: string;
	link: string;
	name: string;
};

const SiteFooter = () => {
	const FooterLink = ({ path, title }: { path: string; title: string }) => (
		<Link
			className="dark:text-white hover:text-primary hover:dark:text-secondary text-right"
			to={path}
		>
			{title}
		</Link>
	);
	const { mode } = useTheme();

	const socailLinks: SocialLinksType[] = [
		{ image: social_FB, link: "http://", name: "fb" },
		{ image: social_Insta, link: "http://", name: "insta" },
		{ image: social_LI, link: "http://", name: "li" },
		{ image: social_Twitter, link: "http://", name: "twitter" },
	];

	return (
		<Footer
			container
			className="absolute bottom-0 rounded-none border-t-2 border-teal w-full flex flex-between gap-8"
			style={{ alignItems: "center", justifyContent: "space-between" }}
		>
			<div className="flex flex-col justify-start items-start gap-4">
				<Navbar.Brand className="w-auto mb-1">
					<img
						className="w-56"
						src={mode === "dark" ? logoDark : logo}
						alt="logo"
					/>
				</Navbar.Brand>
				<div>
					<div className="flex justify-center items-center gap-4">
						{socailLinks.map((social) => (
							<a
								key={social.name}
								href={social.link}
								target="_blank"
								rel="noreferrer"
							>
								<img className="w-6" src={social.image} alt={social.name} />
							</a>
						))}
					</div>
				</div>
			</div>

			<div className="flex max-md:flex-col gap-0 md:gap-8">
				<div className="flex flex-col gap-0 md:gap-1">
					<h4 className="mb-0 text-teal uppercase text-right hidden md:flex">
						Useful links
					</h4>
					<FooterLink title="Blogs and News" path="/blogs-and-news" />
					<FooterLink title="FAQ’s" path="/faqs" />
				</div>
				<div className="flex flex-col gap-0 md:gap-1">
					<h4 className="mb-0 text-teal uppercase text-right hidden md:flex">
						Other Resources
					</h4>
					<FooterLink title="Contact Us" path="/contact-us" />
					<FooterLink title="Privacy Policy" path="/privacy-policy" />
					<FooterLink
						title="Terms and Conditions"
						path="/terms-and-conditions"
					/>
				</div>
			</div>
		</Footer>
	);
};

export default SiteFooter;
